"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Navbar2 = _interopRequireDefault(require("reactstrap/lib/Navbar"));

var _Collapse2 = _interopRequireDefault(require("reactstrap/lib/Collapse"));

var _Nav2 = _interopRequireDefault(require("reactstrap/lib/Nav"));

var _UncontrolledDropdown2 = _interopRequireDefault(require("reactstrap/lib/UncontrolledDropdown"));

var _DropdownMenu2 = _interopRequireDefault(require("reactstrap/lib/DropdownMenu"));

var _DropdownItem2 = _interopRequireDefault(require("reactstrap/lib/DropdownItem"));

var _DropdownToggle2 = _interopRequireDefault(require("reactstrap/lib/DropdownToggle"));

var _NavItem2 = _interopRequireDefault(require("reactstrap/lib/NavItem"));

var _NavLink2 = _interopRequireDefault(require("reactstrap/lib/NavLink"));

var _NavbarToggler2 = _interopRequireDefault(require("reactstrap/lib/NavbarToggler"));

var _NavbarBrand2 = _interopRequireDefault(require("reactstrap/lib/NavbarBrand"));

var _react = _interopRequireWildcard(require("react"));

var _reactstrap = require("reactstrap");

var _CornerstoneBadge = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneBadge"));

var _logo = require("cornerstone_ui_core/lib/utils/logo");

var _CornerstoneAvatar = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneAvatar"));

require("cornerstone_ui_core/lib/containers/BaseLayout/Header/header.scss");

var _cornerstoneLogo = _interopRequireDefault(require("cornerstone_ui_core/lib/assets/img/cornerstone-logo.png"));

var _lodash = require("lodash");

var _NotifyIcon = _interopRequireDefault(require("./NotifyIcon/NotifyIcon"));

var _CornerstoneModal = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneModal"));

var _Persona = _interopRequireDefault(require("../../Persona/Persona"));

var _constants = require("../../../constants");

var _SetLocation = _interopRequireDefault(require("../SetLocation"));

var _IsAuthorized = require("cornerstone_ui_core/lib/components/IsAuthorized");

var _PromiseModalHOC = _interopRequireDefault(require("cornerstone_ui_core/lib/components/PromiseModalHOC"));

var _baseLayout = require("../base-layout.constants");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// import { constructImageUrl } from "../base-layout.constants";
var SetLocationModal = (0, _PromiseModalHOC.default)(_SetLocation.default);

var Header = /*#__PURE__*/function (_React$Component) {
  _inherits(Header, _React$Component);

  var _super = _createSuper(Header);

  function Header(props) {
    var _this;

    _classCallCheck(this, Header);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "initLocation", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.props.getPersonPysicalSiteClaims();

            case 2:
              if (_this.props.physicalSiteClaims && _this.props.physicalSiteClaims.length > 0) {
                _this.props.physicalSiteClaims.map(function (c) {
                  if (c.active === "Y") {
                    _this.props.setLocation(c.siteDescription);

                    localStorage.setItem("claimLocation", c.siteDescription);
                  }
                });
              }

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "openMyPersona", function () {
      _this.setState({
        isPersonaOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onCancel", function () {
      _this.setState({
        isPersonaOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "locationChange", function (e) {
      _this.setLocationRef && _this.setLocationRef.open().then(function (rowData) {}).catch(console.error);
    });

    _defineProperty(_assertThisInitialized(_this), "isRDSAppln", function () {
      if (localStorage.getItem("AppId") === "RDS") {
        return true;
      }

      return false;
    });

    _this.toggle = _this.toggle.bind(_assertThisInitialized(_this));
    _this.onAvatarError = _this.onAvatarError.bind(_assertThisInitialized(_this));
    _this.jobAlertClickHandler = _this.jobAlertClickHandler.bind(_assertThisInitialized(_this));
    _this.handleOuterClicks = _this.handleOuterClicks.bind(_assertThisInitialized(_this));
    _this.state = {
      isOpen: false,
      imageSrc: "",
      showJobAlert: false,
      isPersonaOpen: false
    };
    return _this;
  }

  _createClass(Header, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var imageString = // let imageString =
      this.props.profileImage !== "" && this.props.profileImage !== "No Image" ? "data:image/jpg;base64, " + this.props.profileImage : false;
      this.setState({
        imageSrc: imageString
      }); // if (this.props.user.apps.includes("RDS")) this.isItemToBeAcknowledged();

      if (this.isRDSAppln()) this.initLocation();
    }
  }, {
    key: "toggle",
    value: function toggle() {
      this.setState({
        isOpen: !this.state.isOpen
      });
    }
  }, {
    key: "onAvatarError",
    value: function onAvatarError(e) {
      this.setState({
        imageSrc: ""
      });
    }
    /**
     * Toggles the Job ALert component
     * @param {*} e
     */

  }, {
    key: "jobAlertClickHandler",
    value: function jobAlertClickHandler(e) {
      // e.preventDefault();
      // const { showJobAlert } = this.state;
      // if (!showJobAlert) {
      //   document.addEventListener("click", this.handleOuterClicks, false);
      //   this.setState({
      //     showJobAlert: true
      //   });
      // } else {
      //   document.removeEventListener("click", this.handleOuterClicks, false);
      //   this.setState({
      //     showJobAlert: false
      //   });
      // }
      var show = this.props.showTodo;
      this.props.setTodoStatus(!show);
    }
  }, {
    key: "isItemToBeAcknowledged",
    value: function () {
      var _isItemToBeAcknowledged = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (!(0, _IsAuthorized.isEntitled)({
                  user: this.props.user,
                  perform: _baseLayout.ACTION_TRACKING_MYSELF_PAGED_KEY
                })) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 4;
                return this.props.isActionTrackingToBeAcknowledged({
                  currentPage: 0,
                  pageSize: 50,
                  sortOrder: ""
                });

              case 4:
                _context2.next = 8;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](0);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 6]]);
      }));

      function isItemToBeAcknowledged() {
        return _isItemToBeAcknowledged.apply(this, arguments);
      }

      return isItemToBeAcknowledged;
    }()
  }, {
    key: "handleOuterClicks",
    value: function handleOuterClicks(e) {
      if (!this.node.contains(e.target)) this.jobAlertClickHandler(e);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var imageString = this.state.imageSrc;
      var user = this.props.user;
      var userdept;

      if (user && !(0, _lodash.isNil)(user["department"]) && localStorage.getItem("AppId") === "FEP") {
        userdept = user["department"]["Dept"];
        userdept = (0, _lodash.trim)(userdept); //to remove whitespaces leading to trailing
      } else if (user && !(0, _lodash.isNil)(user["department"])) {
        userdept = user["department"]["Dept"].slice(1, -1); //userdept = userdept.split(" ");
        //userdept.splice(-1, 1);
        //userdept = userdept.join(" ").replace("-", " ");

        userdept = (0, _lodash.replace)(userdept, /([\d*]())/g, ""); //to replace digits

        userdept = (0, _lodash.replace)(userdept, /[()]/g, ""); //to replace paranthesis

        userdept = (0, _lodash.replace)(userdept, "-", " "); //to replace -

        userdept = (0, _lodash.trim)(userdept); //to remove whitespaces leading to trailing
      }

      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_Navbar2.default, {
        className: "app-base-header dropdown",
        expand: "md"
      }, localStorage.getItem("AppId") === "PDS" && this.state.isPersonaOpen && /*#__PURE__*/_react.default.createElement(_Persona.default, _extends({}, this.props, {
        openMyPersona: this.state.isPersonaOpen,
        onCancel: this.onCancel
      })), /*#__PURE__*/_react.default.createElement(_NavbarBrand2.default, {
        className: "top-header-logo",
        href: masterUrl()
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: _logo.logo
      })), /*#__PURE__*/_react.default.createElement(_NavbarToggler2.default, {
        onClick: this.toggle
      }), /*#__PURE__*/_react.default.createElement(_Collapse2.default, {
        isOpen: this.state.isOpen,
        navbar: true
      }, /*#__PURE__*/_react.default.createElement(_Nav2.default, {
        className: "ml-auto",
        navbar: true
      }, this.props.notifyDetails && /*#__PURE__*/_react.default.createElement(_NotifyIcon.default, {
        notifyDetails: this.props.notifyDetails,
        onClick: function onClick(e) {
          return _this2.props.setNotifyClick(true);
        }
      }), this.isRDSAppln() ? /*#__PURE__*/_react.default.createElement(_NavItem2.default, {
        className: "job-alert-nav-item rds-location"
      }, /*#__PURE__*/_react.default.createElement(_NavLink2.default, {
        onClick: function onClick(e) {
          return _this2.locationChange(e);
        }
      }, this.props.rdsLocation)) : "", /*#__PURE__*/_react.default.createElement(_NavItem2.default, {
        className: "job-alert-nav-item " + (this.state.showJobAlert ? "job-nav-item-selected" : "")
      }, /*#__PURE__*/_react.default.createElement(_NavLink2.default, {
        onClick: function onClick(e) {
          return _this2.jobAlertClickHandler(e);
        }
      }, /*#__PURE__*/_react.default.createElement(_CornerstoneBadge.default, {
        style: {
          backgroundColor: "#176e9e"
        },
        count: this.props.isActionTrackingItemsTOBeAcknowledged || null,
        offset: [-20, 6]
      }, /*#__PURE__*/_react.default.createElement(_CornerstoneAvatar.default, {
        className: "top-head-avatar",
        shape: "square",
        size: 40,
        icon: "profile",
        title: "TODO"
      })))), /*#__PURE__*/_react.default.createElement(_UncontrolledDropdown2.default, {
        nav: true,
        inNavbar: true
      }, /*#__PURE__*/_react.default.createElement(_DropdownToggle2.default, {
        nav: true,
        caret: true
      }, user.name && user.name.toUpperCase(), imageString && /*#__PURE__*/_react.default.createElement(_CornerstoneAvatar.default, {
        src: imageString,
        style: {
          borderRadius: "50%",
          height: "40px",
          width: "30px",
          lineHeight: "35px"
        },
        onError: function onError(e) {
          return _this2.onAvatarError(e);
        }
      }), !imageString && /*#__PURE__*/_react.default.createElement(_CornerstoneAvatar.default, {
        size: 40,
        shape: "circle",
        icon: "user",
        style: {
          lineHeight: "32px"
        }
      })), /*#__PURE__*/_react.default.createElement(_DropdownMenu2.default, {
        right: true
      }, /*#__PURE__*/_react.default.createElement(_DropdownItem2.default, null, userdept), /*#__PURE__*/_react.default.createElement(_DropdownItem2.default, null, user.email), _constants.releaseVersion === "R2" && localStorage.getItem("AppId") === "PDS" && /*#__PURE__*/_react.default.createElement(_DropdownItem2.default, {
        onClick: this.openMyPersona
      }, "My Persona"), /*#__PURE__*/_react.default.createElement(_DropdownItem2.default, {
        divider: true
      }), /*#__PURE__*/_react.default.createElement(_DropdownItem2.default, {
        onClick: function onClick() {
          return _this2.props.logout();
        }
      }, "Logout")))))), this.isRDSAppln() ? /*#__PURE__*/_react.default.createElement(SetLocationModal, {
        modalProps: {
          style: {
            top: 0
          },
          width: "30%",
          className: "promise-modal formModal",
          closable: true,
          maskClosable: false,
          title: "Set Location"
        },
        ref: function ref(_ref2) {
          return _this2.setLocationRef = _ref2;
        }
      }) : "");
    }
  }]);

  return Header;
}(_react.default.Component);

exports.default = Header;

function masterUrl() {
  var hostname = window.location.hostname.replace(/^[^.]+\./g, "");
  var port = window.location.port === "" ? "" : ":".concat(window.location.port);
  return "".concat(window.location.protocol, "//").concat(hostname).concat(port);
}